import React, { useEffect } from "react";
import { Button } from "antd";
import {
  ThunderboltOutlined,
  MailOutlined,
  LinkOutlined,
  WhatsAppOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import {
  trackAddonLockCtaClicked,
  trackAddonLockViewed,
} from "util/productAnalytics";
import styles from "./style.module.scss";

const SONIC_PRODUCT_URL = "https://pivony.com/products/engage";

const SonicLockPage = ({ theme = "light" }) => {
  const { t } = useTranslation();

  useEffect(() => {
    trackAddonLockViewed("pivony_sonic");
  }, []);

  return (
    <div
      className={`${styles.sonicLockPage} ${
        theme === "dark" ? styles.sonicLockPageDark : styles.sonicLockPageLight
      }`}
    >
      <div className={styles.sonicLockBackground}>
        <div className={styles.sonicLockGrid} />
        <div className={styles.sonicLockOrbOne} />
        <div className={styles.sonicLockOrbTwo} />
        <div className={styles.sonicLockCardGhostOne}>
          <WhatsAppOutlined />
          <span>{t("sonic_lock.ghost_whatsapp")}</span>
          <strong>{t("sonic_lock.ghost_live")}</strong>
        </div>
        <div className={styles.sonicLockCardGhostTwo}>
          <PhoneOutlined />
          <span>{t("sonic_lock.ghost_voice")}</span>
          <strong>{t("sonic_lock.ghost_ai")}</strong>
        </div>
        <div className={styles.sonicLockRuleGhost}>
          <span>{t("sonic_lock.ghost_trigger")}</span>
          <span>{t("sonic_lock.ghost_template")}</span>
          <span>{t("sonic_lock.ghost_send")}</span>
        </div>
      </div>
      <div className={styles.sonicLockModal}>
        <div className={styles.sonicLockIcon}>
          <ThunderboltOutlined />
        </div>
        <p className={styles.sonicLockEyebrow}>{t("sonic_lock.eyebrow")}</p>
        <h1>{t("sonic_lock.heading")}</h1>
        <p className={styles.sonicLockText}>{t("sonic_lock.body")}</p>
        <div className={styles.sonicLockActions}>
          <Button
            type="primary"
            size="large"
            icon={<MailOutlined />}
            href="mailto:hello@pivony.com?subject=Pivony%20Sonic%20Activation"
            className={styles.sonicLockCtaPrimary}
            onClick={() => trackAddonLockCtaClicked("pivony_sonic", "email")}
          >
            {t("product_lock.talk_to_sales")}
          </Button>
          <Button
            size="large"
            icon={<LinkOutlined />}
            href={SONIC_PRODUCT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.sonicLockCtaSecondary}
            onClick={() => trackAddonLockCtaClicked("pivony_sonic", "read_more")}
          >
            {t("product_lock.upgrade_demo")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SonicLockPage;
